import { LineItem } from 'shared/types/cart';
import { StatsBar } from 'components/ui/atoms/stats-bar';
import { TestimonialCard } from 'components/ui/atoms/testimonial-card/testimonial-card';
import { elementEvents } from 'utils/eventing';
import { MonarchDataConsumer } from 'utils/eventing/monarch/MonarchDataConsumer';
import { CareerCard } from '../../atoms/career-card';
import { ValueReinforcementResult } from '../monarch/rules/valueReinforcement/types';
import { careerCardContent } from './constant/careerCardContent';
import { statsBarContent } from './constant/statsBarContent';
import { getCategory } from './utils/getCategory';
import './styles.scss';

type ValueReinforcementProps = {
  lineItems?: LineItem[];
};

export const ValueReinforcement = ({
  lineItems = [],
}: ValueReinforcementProps) => {
  const category = getCategory(lineItems);

  const { elementViewed: careerCardViewEvent } = elementEvents({
    webElement: {
      elementType: 'career-card',
      htmlId: 'career-card',
      location: 'checkout',
      text: category ?? '',
      name: 'career-card',
    },
  });

  const { elementViewed: statsBarViewEvent } = elementEvents({
    webElement: {
      elementType: 'stats-bar',
      htmlId: 'stats-bar',
      location: 'checkout',
      text: 'stats-bar',
      name: 'stats-bar',
    },
  });

  const { elementViewed: testimonialCardViewEvent } = elementEvents({
    webElement: {
      elementType: 'testimonials-module',
      htmlId: 'testimonials-module',
      location: 'checkout',
      text: category ?? '',
      name: 'testimonials-module',
    },
  });

  return (
    <MonarchDataConsumer<ValueReinforcementResult> experimentKey="useValueReinforcement">
      {(monarchData) => {
        if (monarchData?.variant === 'test' && monarchData?.data) {
          const {
            isCareerCardEnabled,
            isTestimonialCardEnabled,
            isStatsBarEnabled,
            testimonialContent,
          } = monarchData.data;

          if (isCareerCardEnabled && category) {
            const { sectionTitle, stats } = careerCardContent[category];
            const { jobs, salary, growth } = stats;

            return (
              <div className="career-card-wrapper">
                <CareerCard
                  title={sectionTitle}
                  statistics={[salary, jobs, growth]}
                  onView={careerCardViewEvent}
                />
              </div>
            );
          }
          if (testimonialContent && isTestimonialCardEnabled) {
            const { testimonial, bylineImage, bylineName, bylineLocation } =
              testimonialContent;
            return (
              <TestimonialCard
                bylineImage={
                  bylineImage || '/images/default-testimonial-avatar.png'
                }
                bylineName={bylineName || 'edX online learner'}
                bylineLocation={bylineLocation || undefined}
                testimonial={testimonial}
                onView={testimonialCardViewEvent}
              />
            );
          }
          if (isStatsBarEnabled) {
            return (
              <div className="stats-bar-wrapper">
                <StatsBar
                  onView={statsBarViewEvent}
                  statistics={statsBarContent}
                />
              </div>
            );
          }
        }
        return null;
      }}
    </MonarchDataConsumer>
  );
};
